module.exports = __webpack_public_path__ + "static/media/icon-export-white.f46a3a11.svg";